// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';

@Component({
  selector: 'e-auth',
  templateUrl: 'auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
}
